module.exports = __webpack_public_path__ + "static/media/independent-usborne-organiser.c159ac7c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/independent-usborne-organiser.jpeg
// module id = 513
// module chunks = 0